module.exports = __webpack_public_path__ + "static/img/001.50028751.png";